import {
  Church, Wine, UtensilsCrossed, Music, PartyPopper,
  Sparkles, Camera, Heart, Gem, Clock,
} from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

const ICONOS = {
  iglesia: Church,
  copas: Wine,
  cena: UtensilsCrossed,
  musica: Music,
  fiesta: PartyPopper,
  brillo: Sparkles,
  camara: Camera,
  corazon: Heart,
  anillos: Gem,
  reloj: Clock,
};

export default function Itinerario({ datos, seccion }) {
  const items = datos.itinerario || [];
  if (items.length === 0) return null;

  return (
    <section className="ki-seccion" aria-label={seccion.titulo}>
      <div className="ki-seccion-interior">
        <EncabezadoSeccion p="ki" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="ki-titulo-itinerario" />
        <Reveal>
          <ul className="ki-itinerario">
            {items.map((item, i) => {
              const Icono = ICONOS[item.icono] || Clock;
              return (
                <li className="ki-itinerario-item" key={i} data-testid={`ki-itinerario-item-${i}`}>
                  <span className={`ki-itinerario-icono ki-itinerario-icono--${(i % 3) + 1}`}>
                    <Icono strokeWidth={2} />
                  </span>
                  <div>
                    <p className="ki-itinerario-hora">{item.hora}</p>
                    <h3 className="ki-itinerario-titulo">{item.titulo}</h3>
                    {item.descripcion && <p className="ki-itinerario-desc">{item.descripcion}</p>}
                  </div>
                </li>
              );
            })}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
